import React,{useEffect} from 'react'
import { AbstructVar } from '../../../general/general-component/abstruct-component/AbstructVar'
import Analytics_card from './Analytics_card'
import { loadStatistics } from '../../../../store/Actions/ActionStatistics'
import { useSelectorCustom } from '../../../general/general-component/abstruct-component/useSelectorCustom'
import {AbstructLang} from '../../../general/general-component/abstruct-component/AbstructLang'
function Analytics() {
    let { dispatch,mode,navigate,langLocal } = AbstructVar()
    const {statistics,loadingStatistics} = useSelectorCustom()
    const { translate } = AbstructLang();
    useEffect(()=>{
        dispatch(loadStatistics())
    },[])
    return (
        <div className="div_top_main margin_main" dir={langLocal === 'ar'? "rtl": "ltr"} >
            {/*<div className="Congratulations">
                <span className="avatar_content"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg></span>
                <div className="imgsCongratulations" >
                    <img src={congratulations_left} />
                    <img className='imgright' src={congratulations_right} />
                </div>
                <p className="title_Congratulations" >Congratulations John,</p>
                <p className="sub_title_Congratulations">You have done 57.6% more sales today. Check your new badge in your profile.</p>
    </div>*/}
            <Analytics_card num={statistics.users_count} name={translate('TotalUsers')} icon='las la-user-friends' classIcon='satisfactory' />
            <Analytics_card num={statistics.visitors_count} name={translate('TotalVisitors')} icon='las la-user-friends'  classIcon='unacceptable' />
            <Analytics_card num={statistics.creative_works_count} name={translate('TotalCreativeWorks')} icon='fas fa-project-diagram' classIcon='good' />
            <Analytics_card num={statistics.creative_works_unaccepted_count} name={translate('TotalRequestsUnaccepted')} icon='fa-solid fa-close' classIcon='excellent' />
            <Analytics_card num={statistics.creative_works_accepted_count} name={translate('TotalRequestsAccepted')} icon='fa-solid fa-check' classIcon='good' />
            <Analytics_card num={statistics.creative_works_reject_count} name={translate('TotalRequestsRejected')} icon='fa-solid fa-close' classIcon='unacceptable' />
            <Analytics_card num={statistics.creative_evaluation_type_questions_count} name={translate('TotalCreativeEvaluationTypeQuestions')} icon='fa-solid fa-question' classIcon='satisfactory' />
        </div>
    )
}

export default Analytics